import { action, IObservableArray, observable, makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { Store } from '../../store/Store';
import { PortalEnv } from '../../../env/PortalEnv';
import { RequestStoreHost } from '../../store/RequestStore/RequestStoreHost';

export class PortalStore {
  readonly store: Store;

  constructor(store) {
    makeObservable(this);
    this.store = store;
    if (typeof window !== 'undefined') {
      (window as any).portalStore = this;
    }
  }

  @memoize
  get isInIframe(): boolean {
    if (typeof window === 'undefined') return false;
    if (!window.parent) return false;
    return window.location !== window.parent.location;
  }

  get portalData() {
    return this.store.storeData.portalData;
  }

  @observable.shallow metaStylesheets: IObservableArray<string> = observable.array<string>();
  @observable.shallow pageJs: IObservableArray<string> = observable.array<string>();

  @observable isUserPanelOpen: boolean = false;
  @observable isAsidePanelOpen: boolean = false;

  @observable.ref metaTitle: string;
  @observable.ref subheaderTitle: any;

  @action.bound
  includeStylesheetOnce(href: string) {
    if (!this.metaStylesheets.includes(href)) {
      this.metaStylesheets.push(href);
    }
  }

  @action.bound
  includeJsOnce(href: string) {
    if (!this.pageJs.includes(href)) {
      this.pageJs.push(href);
    }
  }
}
